import React, { memo, useMemo } from 'react'
import Box from '@mui/material/Box'
import { useDispatch, useSelector } from 'react-redux'
import { getAllFiltersSelecteds, removeValueFromString } from 'utils/srp'
import pickBy from 'lodash/pickBy'
import { setFilter } from 'redux/modules/map'
import FilterButton from './FilterButton'
import FiltersSelected from './FiltersSelected'
import sx from './styles'

const FiltersRow = ({
  onChange,
  onClickModalFilter,
  onResetAllFilters,
}) => {
  const dispatch = useDispatch()
  const { filters } = useSelector((s) => s.map)
  const filtersSelected = useMemo(() => getAllFiltersSelecteds(filters), [filters])

  // TODO: REFACTOR
  const handleDeleteFilter = (filterItem) => {
    const cleanFiltersObj = pickBy(filters) // Remove all keys void
    Object.keys(cleanFiltersObj)
      .forEach((filterSelected) => {
        const changeToLowerCaseValue = filterSelected === 'state' || filterSelected === 'body' || filterSelected === 'sort' || filterSelected === 'transmission' || filterSelected === 'q'
        if (`${cleanFiltersObj[filterSelected]}`.includes(filterItem)) {
          const removedFilterSelected = removeValueFromString(
            cleanFiltersObj[filterSelected],
            filterItem,
            !changeToLowerCaseValue,
          )
          cleanFiltersObj[filterSelected] = removedFilterSelected
          dispatch(setFilter({ key: filterSelected, value: removedFilterSelected }))
        }
      })
    onChange(cleanFiltersObj)
  }

  return (
    <Box sx={sx.root}>
      <Box sx={sx.filtersSelectedContainer}>
        <FiltersSelected
          items={filtersSelected}
          onDeleteItem={handleDeleteFilter}
          onDeleteAllFilters={onResetAllFilters}
        />
      </Box>
      <Box>
        <FilterButton onClick={onClickModalFilter} />
      </Box>
    </Box>
  )
}

export default memo(FiltersRow)
